import { render, staticRenderFns } from "./List.vue?vue&type=template&id=ac4282f6&"
import script from "../../models/ticket-lottery-management/list.ts?vue&type=script&lang=ts&"
export * from "../../models/ticket-lottery-management/list.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports